import * as angular from 'angular';
import * as _ from 'lodash';

import { Pattern, ComponentDefinition, VariableTableViewModel } from '../../../../models';

class VariableFilterBarController implements angular.IComponentController {
    criteria: Pattern<VariableTableViewModel>[];
    filtered: VariableTableViewModel[];
    
    readonly viewModels: VariableTableViewModel[];

    static $inject = ['$translate'];
    constructor($translate: angular.translate.ITranslateService) {
        this.criteria = [
            {
                property: 'v',
                placeholder: 'Variable type',
                label: 'Variable type',
                model: 'v',
                isMatch: (vm, regexp) => regexp.test($translate.instant(vm.name))
            },
            {
                property: 'vst',
                placeholder: 'Variable subtype',
                label: 'Variable subtype',
                model: 'vst',
                isMatch: (vm, regexp) => regexp.test($translate.instant(vm.subType))
            },
            {
                property: 'u',
                placeholder: 'Unit',
                label: 'Unit',
                model: 'u',
                isMatch: (vm, regexp) => regexp.test($translate.instant(vm.unit))
            },
            {
                property: 'c',
                placeholder: 'Long comment',
                label: 'Long comment',
                model: 'c',
                isMatch: (vm, regexp) => regexp.test($translate.instant(vm.unitComment))
            },
            {
                property: 'al',
                placeholder: 'Alias',
                label: 'Alias',
                model: 'al',
                isMatch: (vm, regexp) => _.some(vm.defaultAliases, a => regexp.test(a.name))
                    || _.some(vm.customAliases, a => regexp.test(a.name))
            }
        ];
    }
}

export const wtVariableFilterBar: ComponentDefinition = {
    componentId: 'wtVariableFilterBar',
    controller: VariableFilterBarController,
    template: require('./variableFilterBar.component.html'),
    controllerAs: 'vm',
    bindings: {
        filtered: '=',
        viewModels: '<'
    }
};
